<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Cerrahi"
    }
</script>

<style scoped>

</style>